import Icon from '../Icon';
import ButtonBase from '../UI/ButtonBase';
import HashLoading from '../UI/Loading/Hash';
import { IButtonCta } from './types';

const ButtonCta: React.FC<IButtonCta> = ({
  title,
  disabled,
  iconLeft,
  iconRight,
  sizeIcon = 18,
  iconName,
  colorTitle = '#fff',
  padding = 15,
  fontSize = 16,
  maxWidth = '100%',
  width = '100%',
  borderRadius = 12,
  isLoading,
  handleClick,
}) => {
  const renderLoadingOrContent = () => {
    if (isLoading) {
      return <HashLoading color="#fff" size={20} />;
    }
    return (
      <>
        {iconLeft && iconName && <Icon iconName={iconName} size={sizeIcon} />}
        {title}
        {iconRight && iconName && <Icon iconName={iconName} size={sizeIcon} />}
      </>
    );
  };

  return (
    <ButtonBase
      disabled={disabled}
      onClick={handleClick}
      padding={padding}
      borderRadius={borderRadius}
      background={'#005F47'}
      alignItems="center"
      fontSize={fontSize}
      gap={5}
      fontWeight={700}
      width={width}
      maxWidth={maxWidth}
      color={colorTitle}
      justifyContent={!iconLeft && !iconRight ? 'center' : 'normal'}
    >
      {renderLoadingOrContent()}
    </ButtonBase>
  );
};

export default ButtonCta;
